<div class="qu-container">

  <!-- ─── Action Bar ─── -->
  <div class="qu-action-bar">

    <!-- Search (left) -->
    <div class="qu-search-wrap">
      <input
        type="text"
        [(ngModel)]="search"
        (ngModelChange)="onSearchChange()"
        placeholder="Search documents..."
        class="qu-input qu-input-search"
      />
      <button *ngIf="search" (click)="search = ''; page = 1; onSearchChange()" class="qu-clear-btn">&#x2715;</button>
    </div>

    <!-- Upload (right) -->
    <button class="qu-btn qu-btn-success" (click)="openAddModal()">Upload PDF</button>

  </div>

  <!-- ─── Table ─── -->
  <div class="qu-table-wrap">

    <!-- Skeleton (loading) -->
    <table *ngIf="loading" class="qu-table">
      <thead>
        <tr>
          <th class="qu-th qu-th-num">#</th>
          <th class="qu-th">Document Name</th>
          <th class="qu-th">File Type</th>
          <th class="qu-th">Total Pages</th>
          <th class="qu-th">Status</th>
          <th class="qu-th">Upload Date</th>
          <th class="qu-th qu-th-action">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let sk of skeletonRows" class="qu-skeleton-row">
          <td class="qu-td"><div class="qu-sk qu-sk-xs"></div></td>
          <td class="qu-td"><div class="qu-sk"></div></td>
          <td class="qu-td"><div class="qu-sk qu-sk-sm"></div></td>
          <td class="qu-td"><div class="qu-sk qu-sk-xs"></div></td>
          <td class="qu-td"><div class="qu-sk qu-sk-sm"></div></td>
          <td class="qu-td"><div class="qu-sk qu-sk-sm"></div></td>
          <td class="qu-td"><div class="qu-sk qu-sk-md"></div></td>
        </tr>
      </tbody>
    </table>

    <!-- Data Table -->
    <table *ngIf="!loading" class="qu-table">
      <thead>
        <tr>
          <th class="qu-th qu-th-num">#</th>
          <th class="qu-th">Document Name</th>
          <th class="qu-th">File Type</th>
          <th class="qu-th">Total Pages</th>
          <th class="qu-th">Status</th>
          <th class="qu-th">Upload Date</th>
          <th class="qu-th qu-th-action">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr
          *ngFor="let row of pageData; let idx = index"
          class="qu-tr"
          [ngClass]="getRowClass(idx)">

          <td class="qu-td qu-td-num">{{ getRowIndex(idx) }}</td>

          <td class="qu-td">{{ row.documentName }}</td>

          <td class="qu-td">{{ getFileType(row.documentName) }}</td>

          <td class="qu-td">{{ row.totalPages }}</td>

          <td class="qu-td">
            <span class="status-badge" [ngClass]="getStatusClass(row.status)">
              {{ row.status === 'PROCESSING' ? 'IN PROGRESS' : row.status }}
            </span>
          </td>

          <td class="qu-td qu-td-size">{{ formatUploadDate(row.uploadDate) }}</td>

          <td class="qu-td qu-td-action">
            <button class="qu-icon-btn qu-icon-btn-download" title="Download PDF" (click)="downloadFile(row)">
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
                <polyline points="7 10 12 15 17 10"/>
                <line x1="12" y1="15" x2="12" y2="3"/>
              </svg>
            </button>
            <button class="qu-icon-btn qu-icon-btn-delete" (click)="confirmDeleteRow(getRowId(row))" title="Delete document">
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="3 6 5 6 21 6"/>
                <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/>
                <path d="M10 11v6M14 11v6"/>
                <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/>
              </svg>
            </button>
          </td>
        </tr>

        <tr *ngIf="pageData.length === 0">
          <td colspan="7" class="qu-td qu-td-empty">No documents found.</td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- ─── Pagination ─── -->
  <div class="qu-pagination">
    <div class="qu-page-nav">
      <button class="qu-btn qu-btn-page" [disabled]="page === 1" (click)="page = page - 1; onPageChange()">Prev</button>
      <button class="qu-btn qu-btn-page" [disabled]="page === totalPages" (click)="page = page + 1; onPageChange()">Next</button>
      <span class="qu-page-info">Page {{ page }} of {{ totalPages }}</span>
    </div>

    <!-- Row count (center) -->
    <span class="qu-count">
      <ng-container *ngIf="search">{{ filtered.length }} of {{ data.length }} documents</ng-container>
      <ng-container *ngIf="!search">{{ data.length }} documents</ng-container>
    </span>

    <div class="qu-rows-wrap">
      <span class="qu-label">Rows per page</span>
      <select [(ngModel)]="rowsPerPage" (ngModelChange)="page = 1; onPageChange()" class="qu-select">
        <option [value]="5">5</option>
        <option [value]="10">10</option>
        <option [value]="25">25</option>
        <option [value]="50">50</option>
      </select>
    </div>
  </div>

</div>

<!-- ─── Hidden File Input ─── -->
<input
  #fileInput
  type="file"
  multiple
  accept=".pdf,application/pdf"
  (change)="onFileSelected($event)"
  style="display: none"
/>

<!-- ─── Upload PDF Modal ─── -->
<div *ngIf="showAddModal" class="qu-overlay" (click)="closeAddModal()">
  <div class="qu-add-modal qu-upload-modal" (click)="$event.stopPropagation()">

    <!-- Modal Header -->
    <div class="qu-add-header">
      <div class="qu-add-header-icon">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
          <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
          <polyline points="17 8 12 3 7 8"/>
          <line x1="12" y1="3" x2="12" y2="15"/>
        </svg>
      </div>
      <span class="qu-add-title">Upload PDF Document</span>
      <button class="qu-close-btn" (click)="closeAddModal()">&#x2715;</button>
    </div>

    <!-- Modal Body -->
    <div class="qu-add-body qu-upload-body">

      <!-- File Upload Zone -->
      <div class="qu-file-upload-zone" (click)="triggerFileInput()" [class.qu-file-selected]="selectedFiles.length > 0">
        <svg *ngIf="selectedFiles.length === 0" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
          <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
          <polyline points="17 8 12 3 7 8"/>
          <line x1="12" y1="3" x2="12" y2="15"/>
        </svg>
        <div class="qu-upload-text">
          <p class="qu-upload-title" *ngIf="selectedFiles.length === 0">Click to upload PDF(s)</p>
          <p class="qu-upload-title" *ngIf="selectedFiles.length === 1">{{ selectedFiles[0].name }}</p>
          <p class="qu-upload-title" *ngIf="selectedFiles.length > 1">{{ selectedFiles.length }} files selected</p>
          <p class="qu-upload-subtitle" *ngIf="selectedFiles.length === 0">or drag and drop</p>
          <p class="qu-upload-subtitle" *ngIf="selectedFiles.length === 1">{{ formatFileSize(selectedFiles[0].size) }}</p>
          <p class="qu-upload-subtitle" *ngIf="selectedFiles.length > 1">
            <ng-container *ngFor="let f of selectedFiles; let last = last">{{ f.name }}<ng-container *ngIf="!last">, </ng-container></ng-container>
          </p>
        </div>
      </div>

      <!-- PDF Preview -->
      <div class="qu-preview-section" *ngIf="pdfPreviewUrl">
        <label class="qu-field-label">PDF Preview</label>
        <div class="qu-pdf-preview">
          <iframe [src]="pdfPreviewUrl" frameborder="0"></iframe>
        </div>
      </div>

      <!-- Upload Progress -->
      <div class="qu-upload-progress" *ngIf="isUploading">
        <div class="qu-progress-bar">
          <div class="qu-progress-fill" [style.width.%]="uploadProgress"></div>
        </div>
        <span class="qu-progress-text">Uploading... {{ uploadProgress }}%</span>
      </div>

    </div>

    <!-- Modal Footer -->
    <div class="qu-add-footer">
      <button class="qu-btn qu-btn-secondary" (click)="closeAddModal()" [disabled]="isUploading">Cancel</button>
      <button class="qu-btn qu-btn-success" (click)="handleAdd()" [disabled]="isUploading || selectedFiles.length === 0">
        <span *ngIf="!isUploading">Upload Document(s)</span>
        <span *ngIf="isUploading">Uploading...</span>
      </button>
    </div>
  </div>
</div>

<!-- ─── PDF Preview Modal ─── -->
<div *ngIf="showPreviewModal" class="qu-overlay" (click)="closePreviewModal()">
  <div class="qu-preview-modal" (click)="$event.stopPropagation()">

    <!-- Modal Header -->
    <div class="qu-preview-header">
      <span class="qu-preview-title">PDF Preview</span>
      <button class="qu-close-btn" (click)="closePreviewModal()">&#x2715;</button>
    </div>

    <!-- Modal Body - Full Screen PDF -->
    <div class="qu-preview-body">
      <!-- <iframe [src]="getPdfDownloadUrl(editRowId || '')" frameborder="0"></iframe> -->
    </div>

    <!-- Modal Footer -->
    <div class="qu-preview-footer">
      <!-- <a [href]="getPdfDownloadUrl(editRowId || '')" download class="qu-btn qu-btn-primary">Download PDF</a> -->
      <button class="qu-btn qu-btn-secondary" (click)="closePreviewModal()">Close</button>
    </div>
  </div>
</div>

<!-- ─── Confirm Delete Modal ─── -->
<div *ngIf="showDeleteModal" class="qu-overlay" (click)="showDeleteModal = false">
  <div class="qu-modal" (click)="$event.stopPropagation()">
    <p class="qu-modal-msg">
      Are you sure you want to delete this document?
      This action cannot be undone.
    </p>
    <div class="qu-modal-actions">
      <button class="qu-btn qu-btn-secondary" (click)="showDeleteModal = false">Cancel</button>
      <button class="qu-btn qu-btn-danger" (click)="handleDelete()">Delete</button>
    </div>
  </div>
</div>

<!-- ─── Toasts ─── -->
<div class="qu-toasts">
  <div
    *ngFor="let t of toasts"
    class="qu-toast"
    [ngClass]="t.type === 'success' ? 'qu-toast-success' : 'qu-toast-error'">
    <span class="qu-toast-icon" [ngClass]="t.type === 'success' ? 'qu-icon-success' : 'qu-icon-error'">
      {{ t.type === 'success' ? '✓' : '✕' }}
    </span>
    <span class="qu-toast-text">{{ t.message }}</span>
  </div>
</div>
